import { Moment } from 'moment';
import { PlannerEventId } from '@/planner/models/ids';
import PlanningTaskType from '../constants/PlanningTaskType';
import AbstractTask from './AbstractTask';
import Appointment from './Appointment';

export default class PlanningTask extends AbstractTask {
  id!: PlannerEventId;
  type!: PlanningTaskType;
  start: Moment | null = null;
  end: Moment | null = null;
  appointment!: Appointment;

  isDossier(): boolean {
    return this.type === PlanningTaskType.DOSSIER;
  }
}